/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
function t(t,n={}){const e=t.getContext("webgl2",n);return e||null}export{t as createContext};
